import { chakra } from '@chakra-ui/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const CkLazyLoadImage = chakra(LazyLoadImage);

export default CkLazyLoadImage;
